import { Box, Typography } from '@mui/material';
import { DiffText } from '@/components/common/diff-text';
import { useTranslations } from '@/i18n/use-translations';

/** Compact published baseline under a changed editable field (word-level removed/added markup). */
export function FieldPublishedBaseline({ publishedValue, draftValue }: { publishedValue: string; draftValue: string }) {
  const t = useTranslations();
  if (!publishedValue && !draftValue) return null;

  return (
    <Box
      sx={{
        mt: 0.5,
        pl: 1,
        borderLeft: '3px solid',
        borderColor: 'warning.main',
      }}
      data-testid="field-published-baseline"
    >
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.25 }}>
        {t('common.published')}
      </Typography>
      <DiffText oldStr={publishedValue} newStr={draftValue} />
    </Box>
  );
}
